'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMoveToOrFromTrash = exports.isMoveFromTrash = exports.isMoveToTrash = undefined;

var _boardConstants = require('../../common/boards/boardConstants');

var isTrashMove = function isTrashMove(location) {
  return location.section === _boardConstants.BOARD_SECTIONS.TRASH;
}; // Constants
var isMoveToTrash = exports.isMoveToTrash = function isMoveToTrash(_ref) {
  var location = _ref.location;
  return isTrashMove(location);
};
var isMoveFromTrash = exports.isMoveFromTrash = function isMoveFromTrash(_ref2) {
  var from = _ref2.from;
  return isTrashMove(from);
};
var isMoveToOrFromTrash = exports.isMoveToOrFromTrash = function isMoveToOrFromTrash(_ref3) {
  var location = _ref3.location,
      from = _ref3.from;
  return isMoveToTrash({ location: location }) || isMoveFromTrash({ from: from });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/elementMoveActionUtil.js
// module id = 729
// module chunks = 0